import { put, call, takeLatest, select } from 'redux-saga/effects';

import { updatePageName } from 'services/page';
import { AsyncAction } from 'types/Action';
import { Store } from 'types/store/Store';
import {
  UpdatePageNameMeta,
  UpdatePageNamePayload,
} from 'types/store/UpdatePageNameState';

import { updatePageNameActions } from '../actions';

function* updatePageNameRequest(
  action: AsyncAction<UpdatePageNameMeta, UpdatePageNamePayload>
) {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const { data } = yield call(
        updatePageName,
        action.meta,
        state.auth.token
      );
      yield put(updatePageNameActions.success(data));
    } catch (e: any) {
      yield put(updatePageNameActions.failed(e.message));
    }
  }
}

function* updatePageNameSuccess(
  action: AsyncAction<UpdatePageNameMeta, UpdatePageNamePayload>
) {
  //
}

function* updatePageNameWatcher(): any {
  yield takeLatest(updatePageNameActions.REQUEST, updatePageNameRequest);
  yield takeLatest(updatePageNameActions.SUCCESS, updatePageNameSuccess);
}

export default updatePageNameWatcher;
